import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../../../components/Button/Button';
import styles from '../ForgotPassword.module.scss';

interface OTPProps {
  email: string;
  otp: string[];
  inputRefs: React.MutableRefObject<(HTMLInputElement | null)[]>;
  otpValue: string;
  otpError: boolean;
  otpVerifyLoading: boolean;
  timer: number;
  formatTime: (seconds: number) => string;
  handleInputChange: (value: string, index: number) => void;
  handleKeyDown: (event: React.KeyboardEvent<HTMLInputElement>, index: number) => void;
  handlePaste: (event: React.ClipboardEvent<HTMLInputElement>) => void;
  handleFocus: (index: number) => void;
  handleOTPVerification: (event: React.FormEvent<HTMLFormElement>) => void;
  handleResendOTP: () => void;
  resendError?: string | null;
}

const OTPVerificationForm: React.FC<OTPProps> = ({
  email,
  otp,
  inputRefs,
  otpValue,
  otpError,
  otpVerifyLoading,
  timer,
  handleInputChange,
  handleKeyDown,
  handlePaste,
  handleFocus,
  handleOTPVerification,
  handleResendOTP,
}) => {
  const { t } = useTranslation('account');

  const isTimerRunning = timer > 0;
  const isResendDisabled = otpValue.length < 4 || otpVerifyLoading;

  return (
    <>
      <p className={styles.cardSubtitle}>
        {t('reset.otp_sent_to', { email })
          .split(email)
          .map((part, i, arr) => {
            const isLast = i === arr.length - 1;
            return (
              <React.Fragment key={i}>
                {part}
                {!isLast && <span style={{ color: 'var(--primary-btn-color, #F59E0B)' }}>{email}</span>}
              </React.Fragment>
            );
          })}
      </p>
      <p className={styles.cardSubtitle} style={{ marginBottom: '24px' }}>
        {t('reset.enter_the_otp')}
      </p>
      <form onSubmit={handleOTPVerification} noValidate>
        <div className="field" style={{ marginBottom: '8px' }}>
          <label htmlFor="otp-input-0" className="fieldLabel" style={{ fontSize: '14px', color: '#fff' }}>
            OTP<span style={{ color: 'var(--alert-error)', marginLeft: '2px' }}>*</span>
          </label>
        </div>
        <div className={styles.otpContainer}>
          {otp.map((value, index) => (
            <input
              id={`otp-input-${index}`}
              key={index}
              ref={(el) => {
                inputRefs.current[index] = el;
              }}
              type="text"
              maxLength={1}
              value={value}
              onChange={(e) => handleInputChange(e.target.value, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              onPaste={handlePaste}
              onFocus={() => handleFocus(index)}
              className={styles.otpInput}
              placeholder="-"
            />
          ))}
        </div>
        <div className={styles.timerContainer}>
          {isTimerRunning ? (
            <span>
              {t('reset.resend_code')} <span>({timer}s)</span>
            </span>
          ) : (
            <span className={styles.resendLink} onClick={handleResendOTP}>
              {t('reset.resend_code')}
            </span>
          )}
        </div>

        <Button type="submit" color="primary" fullWidth size="large" disabled={isResendDisabled} label={t('reset.verify_button')} />
      </form>
    </>
  );
};


export default OTPVerificationForm;
